// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * AdjustCreditsIn
 */
export const zAdjustCreditsIn = z.object({
    amount: z.number().int(),
    detail: z.string().max(500).optional().default('admin adjust')
});

/**
 * AdminFontFaceIn
 */
export const zAdminFontFaceIn = z.object({
    family: z.string().nullish(),
    displayName: z.string().optional().default('Regular'),
    weight: z.number().int().gte(100).lte(900).optional().default(400),
    url: z.string(),
    format: z.string().nullish()
});

/**
 * AdminFontUpsertIn
 */
export const zAdminFontUpsertIn = z.object({
    family: z.string().min(1).max(255),
    displayName: z.string().max(255).nullish(),
    sortOrder: z.number().int().nullish(),
    faces: z.array(zAdminFontFaceIn).nullish(),
    url: z.string().nullish(),
    weight: z.number().int().gte(100).lte(900).nullish().default(400),
    format: z.string().nullish(),
    merge: z.boolean().optional().default(true)
});

/**
 * AgentTurnIn
 *
 * One agent LLM turn (may return tool_calls).
 */
export const zAgentTurnIn = z.object({
    messages: z.array(z.record(z.unknown())).optional(),
    model: z.string().nullish(),
    tools: z.array(z.record(z.unknown())).nullish(),
    project_id: z.string().max(128).nullish(),
    mode: z.string().nullish().default('turn')
});

/**
 * AudioGenerateIn
 */
export const zAudioGenerateIn = z.object({
    prompt: z.string().min(1),
    model: z.string().nullish(),
    voice: z.string().nullish(),
    response_format: z.string().nullish(),
    speed: z.number().nullish()
});

/**
 * AudioJobCreateRequest
 */
export const zAudioJobCreateRequest = z.object({
    prompt: z.string().min(1),
    model: z.string().nullish(),
    voice: z.string().nullish(),
    response_format: z.string().nullish(),
    speed: z.number().nullish(),
    trace_id: z.string().nullish()
});

/**
 * AudioJobCreateResponse
 */
export const zAudioJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * AudioJobStatusResponse
 */
export const zAudioJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * AuthConfigOut
 */
export const zAuthConfigOut = z.object({
    googleEnabled: z.boolean(),
    googleClientId: z.string().nullish(),
    emailEnabled: z.boolean(),
    billingEnabled: z.boolean().optional().default(false)
});

/**
 * BatchDeleteIn
 */
export const zBatchDeleteIn = z.object({
    ids: z.array(z.string()).min(1).max(100)
});

/**
 * BatchDeleteOut
 */
export const zBatchDeleteOut = z.object({
    ok: z.boolean().optional().default(true),
    deleted: z.union([
        z.number().int(),
        z.array(z.unknown())
    ]).optional().default(0)
});

/**
 * Body_admin-admin_fonts_upload
 */
export const zBodyAdminAdminFontsUpload = z.object({
    file: z.string(),
    family: z.string().nullish(),
    displayName: z.string().nullish(),
    weight: z.number().int().optional().default(400)
});

/**
 * Body_design-design_plugins_install
 */
export const zBodyDesignDesignPluginsInstall = z.object({
    file: z.string(),
    overwrite: z.boolean().optional().default(false)
});

/**
 * Body_design-design_skills_import_zip
 */
export const zBodyDesignDesignSkillsImportZip = z.object({
    file: z.string(),
    overwrite: z.boolean().optional().default(false)
});

/**
 * Body_fonts-upload_font_file
 */
export const zBodyFontsUploadFontFile = z.object({
    file: z.string(),
    family: z.string().nullish(),
    displayName: z.string().nullish(),
    weight: z.number().int().optional().default(400)
});

/**
 * Body_import-import_image
 */
export const zBodyImportImportImage = z.object({
    file: z.string()
});

/**
 * Body_import-jobs-create_import_job
 */
export const zBodyImportJobsCreateImportJob = z.object({
    file: z.string(),
    source_type: z.literal('image')
});

/**
 * ByokProviderIn
 */
export const zByokProviderIn = z.object({
    id: z.string().nullish(),
    name: z.string().optional().default(''),
    website: z.string().optional().default(''),
    baseUrl: z.string().optional().default(''),
    apiModel: z.string().optional().default(''),
    modelKind: z.string().optional().default('text'),
    apiKey: z.string().nullish()
});

/**
 * CanvasCommandAckIn
 */
export const zCanvasCommandAckIn = z.object({
    seq: z.number().int().gte(0)
});

/**
 * CanvasToolIn
 */
export const zCanvasToolIn = z.object({
    opKey: z.string(),
    kind: z.string().optional().default('node'),
    label: z.string().optional().default(''),
    modelHint: z.string().optional().default(''),
    argsSchema: z.string().optional().default(''),
    enabled: z.boolean().optional().default(true),
    sortOrder: z.number().int().optional().default(0)
});

/**
 * CaptchaVerifyIn
 */
export const zCaptchaVerifyIn = z.object({
    captchaId: z.string().min(8).max(64),
    x: z.number(),
    email: z.string().min(3).max(254),
    trajectory: z.array(z.record(z.unknown())).nullish()
});

/**
 * CreateOrgIn
 */
export const zCreateOrgIn = z.object({
    name: z.string().max(120).optional().default('Untitled org')
});

/**
 * CreateShareIn
 */
export const zCreateShareIn = z.object({
    name: z.string().max(255).optional().default('Untitled'),
    permission: z.string().max(16).optional().default('preview'),
    document: z.record(z.unknown()).nullish(),
    sourceProjectId: z.string().max(64).nullish(),
    editorUserIds: z.array(z.string()).optional(),
    viewerUserIds: z.array(z.string()).optional(),
    linkPublic: z.boolean().nullish()
});

/**
 * DesignDictIn
 */
export const zDesignDictIn = z.object({
    id: z.number().int().nullish(),
    dictType: z.string().min(1).max(32),
    code: z.string().min(1).max(64),
    label: z.string().min(1).max(128),
    sortOrder: z.number().int().optional().default(0),
    enabled: z.boolean().optional().default(true)
});

/**
 * DesignDictTypeIn
 */
export const zDesignDictTypeIn = z.object({
    id: z.number().int().nullish(),
    code: z.string().min(1).max(64),
    label: z.string().min(1).max(128),
    sortOrder: z.number().int().optional().default(0),
    enabled: z.boolean().optional().default(true)
});

/**
 * DesignResumeIn
 */
export const zDesignResumeIn = z.object({
    resume_token: z.string().nullish()
});

/**
 * DesignRunIn
 */
export const zDesignRunIn = z.object({
    run_mode: z.string(),
    prompt: z.string().min(1),
    scene: z.string().nullish(),
    style_group_id: z.number().int().nullish(),
    user_selected_model: z.string().nullish().default('auto'),
    route_overrides: z.record(z.string()).nullish(),
    canvas_id: z.string().nullish(),
    canvas_size: z.string().nullish(),
    ref_image_sizes: z.array(z.string()).nullish(),
    target_layer_id: z.string().nullish(),
    layer_ids: z.array(z.string()).nullish(),
    current_svg: z.string().nullish(),
    scene_nodes: z.array(z.record(z.unknown())).nullish(),
    scene_frames: z.array(z.record(z.unknown())).nullish(),
    spatial_summary: z.record(z.unknown()).nullish(),
    focus_frame_id: z.string().nullish(),
    images: z.array(z.string()).nullish(),
    session_id: z.string().max(64).nullish(),
    project_id: z.string().max(128).nullish(),
    memory: z.record(z.unknown()).nullish(),
    apply_ops: z.array(z.record(z.unknown())).nullish(),
    proposal_id: z.string().max(64).nullish(),
    proposal_task_id: z.string().max(64).nullish(),
    interaction_mode: z.string().nullish(),
    paint_mode: z.string().nullish(),
    skill_refs: z.array(z.string()).nullish(),
    locale: z.string().max(16).nullish(),
    design_intensity: z.string().max(16).nullish()
});

/**
 * DesignSkillIn
 */
export const zDesignSkillIn = z.object({
    id: z.number().int().nullish(),
    skillKey: z.string().max(64).nullish(),
    name: z.string().min(1).max(128),
    description: z.string().optional().default(''),
    category: z.string().max(32).optional().default('agent'),
    whenToUse: z.string().optional().default(''),
    promptPositive: z.string().optional().default(''),
    promptNegative: z.string().optional().default(''),
    preferredTools: z.union([
        z.array(z.string()),
        z.string()
    ]).nullish(),
    allowedResources: z.union([
        z.array(z.string()),
        z.string()
    ]).nullish(),
    inputSchema: z.union([
        z.record(z.unknown()),
        z.string()
    ]).nullish(),
    outputSchema: z.union([
        z.record(z.unknown()),
        z.string()
    ]).nullish(),
    namespace: z.string().max(16).nullish().default('user'),
    ownerUserId: z.string().max(64).nullish(),
    triggers: z.union([
        z.array(z.unknown()),
        z.record(z.unknown()),
        z.string()
    ]).nullish(),
    mutexGroup: z.string().max(64).optional().default(''),
    version: z.number().int().optional().default(0),
    packVersion: z.string().max(32).nullish(),
    logo: z.string().nullish(),
    locales: z.union([
        z.record(z.unknown()),
        z.string()
    ]).nullish(),
    scenes: z.string().max(128).optional().default('all'),
    sortWeight: z.number().int().optional().default(0),
    enabled: z.boolean().optional().default(true),
    defaultModel: z.string().optional().default('doubao'),
    maxRetries: z.number().int().optional().default(2),
    outputFormat: z.string().optional().default('json'),
    allowUserModelOverride: z.boolean().optional().default(false)
});

/**
 * DlqReplayIn
 */
export const zDlqReplayIn = z.object({
    jobId: z.string().min(1).max(64)
});

/**
 * EmailActivateIn
 */
export const zEmailActivateIn = z.object({
    id: z.string().min(8).max(128)
});

/**
 * EmailLoginIn
 */
export const zEmailLoginIn = z.object({
    email: z.string().min(3).max(254),
    password: z.string().min(6).max(128),
    captchaToken: z.string().max(128).nullish()
});

/**
 * EmailSendCodeIn
 */
export const zEmailSendCodeIn = z.object({
    email: z.string().min(3).max(254),
    captchaToken: z.string().max(128).nullish()
});

/**
 * EmailVerifyCodeIn
 */
export const zEmailVerifyCodeIn = z.object({
    email: z.string().min(3).max(254),
    code: z.string().min(4).max(8),
    captchaToken: z.string().max(128).nullish()
});

/**
 * ExportJobCreateRequest
 */
export const zExportJobCreateRequest = z.object({
    projectId: z.string().min(1).max(64),
    format: z.literal('png').optional().default('png'),
    frameId: z.string().max(64).nullish(),
    trace_id: z.string().nullish()
});

/**
 * ExportJobCreateResponse
 */
export const zExportJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * ExportJobStatusResponse
 */
export const zExportJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * FontFaceIn
 */
export const zFontFaceIn = z.object({
    family: z.string().nullish(),
    displayName: z.string().optional().default('Regular'),
    weight: z.number().int().optional().default(400),
    url: z.string(),
    format: z.string().nullish()
});

/**
 * FontRegisterIn
 *
 * Register a font family via CDN/URL faces (or a single url).
 */
export const zFontRegisterIn = z.object({
    family: z.string().min(1).max(255),
    displayName: z.string().max(255).nullish(),
    url: z.string().nullish(),
    format: z.string().nullish(),
    weight: z.number().int().gte(100).lte(900).nullish().default(400),
    faces: z.array(zFontFaceIn).nullish()
});

/**
 * GenerateCardKeysIn
 */
export const zGenerateCardKeysIn = z.object({
    count: z.number().int().gte(1).lte(100).optional().default(10),
    kind: z.string().max(16).optional().default('credit'),
    credits: z.number().int().gte(0).lte(50000000).optional().default(0),
    planId: z.string().max(16).nullish(),
    expiresDays: z.number().int().gte(0).lte(3650).optional().default(365),
    password: z.string().min(1).max(128)
});

/**
 * GoogleAuthIn
 *
 * GIS ID token (`credential`) or OAuth auth-code (`code`) from redirect/popup.
 */
export const zGoogleAuthIn = z.object({
    credential: z.string().min(1).nullish(),
    code: z.string().min(1).nullish(),
    redirectUri: z.string().min(1).nullish()
});

/**
 * HydrateJobCreateRequest
 */
export const zHydrateJobCreateRequest = z.object({
    ops: z.array(z.record(z.unknown())).optional(),
    limit: z.number().int().gte(1).lte(24).optional().default(6),
    policy: z.string().optional().default('auto'),
    rules: z.record(z.string()).nullish(),
    trace_id: z.string().nullish()
});

/**
 * HydrateJobCreateResponse
 */
export const zHydrateJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * HydrateJobStatusResponse
 */
export const zHydrateJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * IdsOut
 */
export const zIdsOut = z.object({
    ids: z.array(z.string())
});

/**
 * ImageGenerateIn
 */
export const zImageGenerateIn = z.object({
    prompt: z.string().min(1),
    model: z.string().nullish(),
    aspect_ratio: z.string().nullish(),
    quality: z.string().nullish(),
    resolution: z.string().nullish(),
    n: z.number().int().nullish(),
    images: z.array(z.string()).nullish()
});

/**
 * ImageJobCreateRequest
 */
export const zImageJobCreateRequest = z.object({
    prompt: z.string().min(1),
    model: z.string().nullish(),
    aspect_ratio: z.string().nullish(),
    quality: z.string().nullish(),
    resolution: z.string().nullish(),
    n: z.number().int().nullish(),
    images: z.array(z.string()).nullish(),
    trace_id: z.string().nullish()
});

/**
 * ImageJobCreateResponse
 */
export const zImageJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * ImageJobStatusResponse
 */
export const zImageJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * ImageProcessIn
 */
export const zImageProcessIn = z.object({
    kind: z.string().min(1),
    image: z.string().min(1),
    meta: z.record(z.unknown()).nullish(),
    aspect_ratio: z.string().nullish(),
    quality: z.string().nullish(),
    resolution: z.string().nullish(),
    model: z.string().nullish()
});

/**
 * ImageProcessJobCreateRequest
 */
export const zImageProcessJobCreateRequest = z.object({
    kind: z.string().min(1),
    image: z.string().min(1),
    meta: z.record(z.unknown()).nullish(),
    aspect_ratio: z.string().nullish(),
    quality: z.string().nullish(),
    resolution: z.string().nullish(),
    model: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * ImageProcessJobCreateResponse
 */
export const zImageProcessJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * ImageProcessJobStatusResponse
 */
export const zImageProcessJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * ImportMeta
 */
export const zImportMeta = z.object({
    source_type: z.literal('image'),
    page_count: z.number().int().optional().default(1),
    page_images: z.array(z.string()).optional(),
    object_keys: z.array(z.string()).optional(),
    object_urls: z.array(z.string()).optional(),
    palette: z.array(z.string()).optional(),
    engines: z.array(z.string()).optional(),
    warnings: z.array(z.string()).optional()
});

/**
 * ImportResponse
 */
export const zImportResponse = z.object({
    job_id: z.string().nullish(),
    status: z.enum([
        'done',
        'processing',
        'failed',
        'queued'
    ]).optional().default('done'),
    document: z.record(z.unknown()).nullish(),
    meta: zImportMeta.nullish(),
    progress: z.number().int().nullish(),
    error: z.string().nullish()
});

/**
 * InviteMemberIn
 */
export const zInviteMemberIn = z.object({
    userId: z.string().max(64).nullish(),
    email: z.string().max(320).nullish(),
    role: z.string().max(16).optional().default('member')
});

/**
 * ItemOut
 */
export const zItemOut = z.object({
    item: z.record(z.unknown())
});

/**
 * ItemsOut
 */
export const zItemsOut = z.object({
    items: z.array(z.unknown()).optional()
});

/**
 * JobCreateResponse
 */
export const zJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.literal('queued').optional().default('queued')
});

/**
 * JobStatusResponse
 */
export const zJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.enum([
        'queued',
        'processing',
        'done',
        'failed'
    ]),
    progress: z.number().int().optional().default(0),
    document: z.record(z.unknown()).nullish(),
    meta: zImportMeta.nullish(),
    error: z.string().nullish()
});

/**
 * LongMemoryIn
 */
export const zLongMemoryIn = z.object({
    kind: z.string().max(32).optional().default('preference'),
    text: z.string().min(1).max(2000),
    pinned: z.boolean().optional().default(false)
});

/**
 * LottieGenerateIn
 */
export const zLottieGenerateIn = z.object({
    prompt: z.string().min(1).max(2000),
    width: z.number().int().gte(32).lte(2048).optional().default(200),
    height: z.number().int().gte(32).lte(2048).optional().default(200),
    duration_sec: z.number().gte(0.5).lte(30).optional().default(3),
    model: z.string().max(128).nullish(),
    images: z.array(z.string()).max(8).nullish()
});

/**
 * LottieJobCreateRequest
 */
export const zLottieJobCreateRequest = z.object({
    prompt: z.string().min(1).max(2000),
    width: z.number().int().gte(32).lte(2048).optional().default(200),
    height: z.number().int().gte(32).lte(2048).optional().default(200),
    duration_sec: z.number().gte(0.5).lte(30).optional().default(3),
    model: z.string().nullish(),
    images: z.array(z.string()).max(8).nullish(),
    trace_id: z.string().nullish()
});

/**
 * LottieJobCreateResponse
 */
export const zLottieJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * LottieJobStatusResponse
 */
export const zLottieJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * McpHeartbeatIn
 */
export const zMcpHeartbeatIn = z.object({
    project_id: z.string().min(1).max(128)
});

/**
 * McpPendingAckIn
 */
export const zMcpPendingAckIn = z.object({
    project_id: z.string().min(1).max(128),
    batch_ids: z.array(z.string()).optional()
});

/**
 * McpToolCallIn
 */
export const zMcpToolCallIn = z.object({
    tool: z.string().min(1).max(128),
    arguments: z.record(z.unknown()).optional()
});

/**
 * Message
 */
export const zMessage = z.object({
    message: z.string()
});

/**
 * MockupAutoBakeIn
 */
export const zMockupAutoBakeIn = z.object({
    image: z.string().min(1),
    scale: z.number().gte(0.25).lte(1).optional().default(0.5)
});

/**
 * MockupBatchItemIn
 */
export const zMockupBatchItemIn = z.object({
    image: z.string().min(1),
    template_id: z.string().min(1).optional().default('demo-cylinder'),
    name: z.string().optional().default('')
});

/**
 * MockupBatchIn
 */
export const zMockupBatchIn = z.object({
    items: z.array(zMockupBatchItemIn).min(1).max(64)
});

/**
 * MockupRenderIn
 */
export const zMockupRenderIn = z.object({
    image: z.string().min(1),
    template_id: z.string().min(1).optional().default('demo-cylinder')
});

/**
 * ModelUpsertIn
 */
export const zModelUpsertIn = z.object({
    id: z.string().min(1).max(128),
    label: z.string().min(1).max(255),
    kind: z.enum(['text', 'image']).optional().default('text'),
    referenceTypes: z.array(z.enum([
        'text',
        'vision',
        'image'
    ])).optional(),
    provider: z.string().max(64).optional().default('doubao'),
    apiModel: z.string().min(1).max(255),
    description: z.string().max(2000).nullish(),
    iconKey: z.string().max(64).nullish(),
    iconUrl: z.string().max(2000).nullish(),
    price: z.string().max(255).nullish(),
    maxAttachments: z.number().int().gte(0).lte(64).optional().default(8),
    thinking: z.boolean().optional().default(false),
    enabled: z.boolean().optional().default(true),
    sortOrder: z.number().int().gte(0).lte(100000).optional().default(100),
    imageLimits: z.record(z.unknown()).nullish(),
    imageLimitPreset: z.string().max(64).nullish(),
    priceMeta: z.record(z.unknown()).nullish(),
    pricingId: z.string().max(128).nullish()
});

/**
 * NoticeIn
 */
export const zNoticeIn = z.object({
    id: z.string().nullish(),
    kind: z.enum(['announcement', 'notification']).optional().default('announcement'),
    title: z.string().min(1).max(200),
    body: z.string().min(1).max(8000),
    status: z.enum(['draft', 'published']).optional().default('draft'),
    publishedAt: z.number().nullish()
});

/**
 * OkOut
 */
export const zOkOut = z.object({
    ok: z.boolean().optional().default(true)
});

/**
 * PatchProjectIn
 */
export const zPatchProjectIn = z.object({
    name: z.string().max(255).nullish(),
    baseRevision: z.number().int().nullish(),
    thumbnailUrls: z.array(z.string()).nullish(),
    thumbnailCustom: z.boolean().nullish(),
    upsertNodes: z.record(z.unknown()).nullish(),
    removeNodeIds: z.array(z.string()).nullish(),
    pageChildren: z.array(z.string()).nullish(),
    frames: z.array(z.unknown()).nullish(),
    activeFrameId: z.string().nullish(),
    canvas: z.record(z.unknown()).nullish()
});

/**
 * PlazaCoverIn
 *
 * Custom list-cover image URL (from /uploads). Empty string clears.
 */
export const zPlazaCoverIn = z.object({
    url: z.string().max(2000).nullish()
});

/**
 * PlazaTitleIn
 */
export const zPlazaTitleIn = z.object({
    title: z.string().min(1).max(120)
});

/**
 * PlazaVisibilityIn
 */
export const zPlazaVisibilityIn = z.object({
    visible: z.boolean()
});

/**
 * PricingVersionIn
 */
export const zPricingVersionIn = z.object({
    pricingVersionId: z.string().nullish(),
    pricingId: z.string().nullish(),
    provider: z.string().nullish(),
    modelId: z.string().nullish(),
    currency: z.string().optional().default('USD'),
    rates: z.array(z.record(z.unknown())).optional(),
    status: z.string().nullish().default('draft'),
    effectiveFrom: z.number().nullish(),
    effectiveTo: z.number().nullish(),
    source: z.string().nullish(),
    notes: z.string().nullish()
});

/**
 * ProfileIn
 */
export const zProfileIn = z.object({
    name: z.string().max(80).nullish(),
    bio: z.string().max(2000).nullish(),
    avatar: z.string().max(2000000).nullish()
});

/**
 * ProjectListOut
 */
export const zProjectListOut = z.object({
    items: z.array(z.record(z.unknown())).nullish(),
    projects: z.array(z.record(z.unknown())).nullish(),
    page: z.number().int().nullish(),
    pageSize: z.number().int().nullish(),
    total: z.number().int().nullish(),
    hasMore: z.boolean().nullish()
});

/**
 * ProjectOneOut
 */
export const zProjectOneOut = z.object({
    project: z.record(z.unknown())
});

/**
 * RedeemIn
 */
export const zRedeemIn = z.object({
    code: z.string().min(16).max(48)
});

/**
 * RegisterAssetIn
 *
 * Register an already-uploaded media object into the Assets dock.
 */
export const zRegisterAssetIn = z.object({
    kind: z.string().min(1).max(16),
    url: z.string().min(1).max(4000),
    objectKey: z.string().max(512).nullish(),
    mime: z.string().max(128).nullish(),
    prompt: z.string().max(500).nullish(),
    width: z.number().int().nullish(),
    height: z.number().int().nullish(),
    source: z.string().max(32).nullish()
});

/**
 * RenameOrgIn
 */
export const zRenameOrgIn = z.object({
    name: z.string().min(1).max(120)
});

/**
 * RevokeCardKeysIn
 */
export const zRevokeCardKeysIn = z.object({
    ids: z.array(z.string()).min(1).max(200)
});

/**
 * RoomTokenIn
 */
export const zRoomTokenIn = z.object({
    projectId: z.string().max(64).nullish(),
    shareId: z.string().max(64).nullish()
});

/**
 * RuntimeSettingIn
 *
 * Whitelist settings still edited from 推理集群 (not the old rules table UI).
 */
export const zRuntimeSettingIn = z.object({
    key: z.string().min(1).max(96),
    value: z.string().optional().default('')
});

/**
 * SceneFeedbackIn
 */
export const zSceneFeedbackIn = z.object({
    scene_nodes: z.array(z.record(z.unknown())).optional(),
    scene_frames: z.array(z.record(z.unknown())).optional(),
    spatial_summary: z.record(z.unknown()).nullish(),
    op_results: z.array(z.record(z.unknown())).nullish(),
    round: z.number().int().nullish(),
    transaction_id: z.string().nullish(),
    transaction_status: z.string().nullish(),
    base_revision: z.number().int().nullish()
});

/**
 * SetProjectOrgIn
 *
 * Attach project to an org, or null to detach (owner only).
 */
export const zSetProjectOrgIn = z.object({
    orgId: z.string().max(64).nullish()
});

/**
 * SubmitIn
 */
export const zSubmitIn = z.object({
    projectId: z.string().min(1).max(128),
    title: z.string().max(120).optional().default(''),
    category: z.string().max(32).optional().default('website'),
    document: z.record(z.unknown()),
    thumbnailUrl: z.union([
        z.string(),
        z.array(z.string())
    ]).nullish()
});

/**
 * SyncLikedIn
 */
export const zSyncLikedIn = z.object({
    ids: z.array(z.string()).optional()
});

/**
 * SyncPricesIn
 */
export const zSyncPricesIn = z.object({
    provider: z.enum(['openrouter', 'ark']).optional().default('openrouter'),
    onlyEmpty: z.boolean().optional().default(false)
});

/**
 * SystemPromptIn
 */
export const zSystemPromptIn = z.object({
    key: z.string().min(1).max(128),
    body: z.string().optional().default(''),
    label: z.string().nullish(),
    description: z.string().nullish(),
    group: z.string().nullish(),
    selectable: z.boolean().nullish(),
    sortOrder: z.number().int().nullish(),
    enabled: z.boolean().nullish()
});

/**
 * UpdateShareDocumentIn
 */
export const zUpdateShareDocumentIn = z.object({
    document: z.record(z.unknown())
});

/**
 * UpdateShareMetaIn
 */
export const zUpdateShareMetaIn = z.object({
    permission: z.string().max(16).nullish(),
    editorUserIds: z.array(z.string()).nullish(),
    viewerUserIds: z.array(z.string()).nullish(),
    name: z.string().max(255).nullish(),
    linkEnabled: z.boolean().nullish(),
    linkPublic: z.boolean().nullish()
});

/**
 * UploadJobStatusResponse
 */
export const zUploadJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    received_parts: z.array(z.number().int()).nullish(),
    part_count: z.number().int().nullish(),
    part_size: z.number().int().nullish()
});

/**
 * UploadPartResponse
 */
export const zUploadPartResponse = z.object({
    part_number: z.number().int(),
    received: z.number().int(),
    part_count: z.number().int(),
    progress: z.number().int()
});

/**
 * UploadSessionCreate
 */
export const zUploadSessionCreate = z.object({
    filename: z.string().min(1).max(512),
    content_type: z.string().nullish(),
    total_size: z.number().int().gt(0)
});

/**
 * UploadSessionResponse
 */
export const zUploadSessionResponse = z.object({
    job_id: z.string(),
    part_size: z.number().int(),
    part_count: z.number().int()
});

/**
 * UpsertProjectIn
 */
export const zUpsertProjectIn = z.object({
    id: z.string().max(64).nullish(),
    name: z.string().max(255).optional().default('Untitled'),
    document: z.record(z.unknown()).nullish(),
    thumbnailUrls: z.array(z.string()).nullish(),
    thumbnailCustom: z.boolean().nullish(),
    baseRevision: z.number().int().nullish(),
    orgId: z.string().max(64).nullish()
});

/**
 * UserPatchIn
 */
export const zUserPatchIn = z.object({
    role: z.enum(['user', 'admin']).nullish(),
    status: z.enum(['active', 'disabled']).nullish(),
    name: z.string().max(80).nullish()
});

/**
 * UserPublic
 */
export const zUserPublic = z.object({
    id: z.string(),
    email: z.string().nullish(),
    name: z.string().nullish(),
    avatar: z.string().nullish(),
    provider: z.string().nullish(),
    role: z.string().nullish(),
    bio: z.string().nullish()
});

/**
 * AuthMeOut
 */
export const zAuthMeOut = z.object({
    user: zUserPublic
});

/**
 * AuthSessionOut
 */
export const zAuthSessionOut = z.object({
    user: zUserPublic,
    token: z.string()
});

/**
 * UserSkillEnabledIn
 */
export const zUserSkillEnabledIn = z.object({
    enabled: z.boolean()
});

/**
 * UserSkillIn
 */
export const zUserSkillIn = z.object({
    id: z.number().int().nullish(),
    name: z.string().min(1).max(128),
    description: z.string().max(2000).nullish(),
    whenToUse: z.string().max(2000).nullish(),
    promptPositive: z.string().min(1).max(120000),
    promptNegative: z.string().max(40000).nullish(),
    skillKey: z.string().max(64).nullish(),
    logo: z.string().max(80000).nullish(),
    category: z.string().max(64).nullish(),
    enabled: z.boolean().optional().default(true)
});

/**
 * ValidationError
 */
export const zValidationError = z.object({
    loc: z.array(z.union([z.string(), z.number().int()])),
    msg: z.string(),
    type: z.string(),
    input: z.unknown().optional(),
    ctx: z.record(z.unknown()).optional()
});

/**
 * HTTPValidationError
 */
export const zHttpValidationError = z.object({
    detail: z.array(zValidationError).optional()
});

/**
 * VideoGenerateIn
 */
export const zVideoGenerateIn = z.object({
    prompt: z.string().min(1),
    model: z.string().nullish(),
    aspect_ratio: z.string().nullish(),
    resolution: z.string().nullish(),
    duration: z.number().int().nullish(),
    images: z.array(z.string()).nullish()
});

/**
 * VideoJobCreateRequest
 */
export const zVideoJobCreateRequest = z.object({
    prompt: z.string().min(1),
    model: z.string().nullish(),
    aspect_ratio: z.string().nullish(),
    resolution: z.string().nullish(),
    duration: z.number().int().nullish(),
    images: z.array(z.string()).nullish(),
    trace_id: z.string().nullish()
});

/**
 * VideoJobCreateResponse
 */
export const zVideoJobCreateResponse = z.object({
    job_id: z.string(),
    status: z.string().optional().default('queued'),
    trace_id: z.string().optional().default('')
});

/**
 * VideoJobStatusResponse
 */
export const zVideoJobStatusResponse = z.object({
    job_id: z.string(),
    status: z.string(),
    progress: z.number().int().optional().default(0),
    result: z.record(z.unknown()).nullish(),
    error: z.string().nullish(),
    trace_id: z.string().nullish()
});

/**
 * RejectIn
 */
export const zAppApiRoutesAdminBillingRejectIn = z.object({
    notes: z.string().optional().default('')
});

/**
 * RejectIn
 */
export const zAppApiRoutesAdminCommonRejectIn = z.object({
    reason: z.string().max(500).nullish()
});

/**
 * ChatMessageIn
 */
export const zAppApiRoutesChatChatMessageIn = z.object({
    message: z.string().min(1),
    model: z.string().nullish(),
    history: z.array(z.record(z.string())).optional(),
    thinking: z.boolean().nullish()
});

/**
 * ChatMessageIn
 */
export const zAppApiRoutesChatSessionsChatMessageIn = z.object({
    id: z.string().nullish(),
    role: z.string().optional().default('user'),
    content: z.string().optional().default(''),
    contexts: z.array(z.record(z.unknown())).nullish(),
    contentMarked: z.string().nullish(),
    thinking: z.string().nullish(),
    durationMs: z.number().int().nullish(),
    intent: z.string().nullish(),
    steps: z.array(z.record(z.unknown())).nullish(),
    images: z.array(z.string()).nullish()
});

/**
 * UpsertSessionIn
 */
export const zUpsertSessionIn = z.object({
    projectId: z.string().max(128).optional().default('__none__'),
    id: z.string().max(64).nullish(),
    title: z.string().max(255).optional().default(''),
    messages: z.array(zAppApiRoutesChatSessionsChatMessageIn).optional(),
    taskState: z.record(z.unknown()).nullish()
});

/**
 * RejectIn
 */
export const zAppApiRoutesPlazaRejectIn = z.object({
    reason: z.string().max(500).nullish()
});

/**
 * Successful Response
 */
export const zAuthAuthConfigResponse = zAuthConfigOut;

export const zAuthAuthGoogleBody = zGoogleAuthIn;

/**
 * Successful Response
 */
export const zAuthAuthGoogleResponse = zAuthSessionOut;

export const zAuthEmailSendCodeBody = zEmailSendCodeIn;

/**
 * Response Auth-Email Send Code
 *
 * Successful Response
 */
export const zAuthEmailSendCodeResponse = z.record(z.unknown());

export const zAuthEmailActivateBody = zEmailActivateIn;

/**
 * Successful Response
 */
export const zAuthEmailActivateResponse = zAuthSessionOut;

export const zAuthEmailVerifyCodeBody = zEmailVerifyCodeIn;

/**
 * Successful Response
 */
export const zAuthEmailVerifyCodeResponse = zAuthSessionOut;

/**
 * Response Auth-Captcha Create
 *
 * Successful Response
 */
export const zAuthCaptchaCreateResponse = z.record(z.unknown());

export const zAuthCaptchaVerifyBody = zCaptchaVerifyIn;

/**
 * Response Auth-Captcha Verify
 *
 * Successful Response
 */
export const zAuthCaptchaVerifyResponse = z.record(z.unknown());

export const zAuthEmailLoginBody = zEmailLoginIn;

/**
 * Successful Response
 */
export const zAuthEmailLoginResponse = zAuthSessionOut;

/**
 * Successful Response
 */
export const zAuthAuthMeResponse = zAuthMeOut;

export const zAuthAuthPatchProfileBody = zProfileIn;

/**
 * Response Auth-Auth Patch Profile
 *
 * Successful Response
 */
export const zAuthAuthPatchProfileResponse = z.record(z.unknown());

/**
 * Successful Response
 */
export const zAuthAuthLogoutResponse = zMessage;

/**
 * Response Wallet-Wallet Plans
 *
 * Successful Response
 */
export const zWalletWalletPlansResponse = z.record(z.unknown());

/**
 * Response Wallet-Purchase Info
 *
 * Successful Response
 */
export const zWalletPurchaseInfoResponse = z.record(z.unknown());

/**
 * Response Wallet-Wallet Me
 *
 * Successful Response
 */
export const zWalletWalletMeResponse = z.record(z.unknown());

export const zWalletWalletLedgerQuery = z.object({
    page: z.number().int().optional().default(1),
    pageSize: z.number().int().optional().default(15),
    kind: z.string().optional().default('all')
});

/**
 * Response Wallet-Wallet Ledger
 *
 * Successful Response
 */
export const zWalletWalletLedgerResponse = z.record(z.unknown());

export const zWalletWalletRedeemBody = zRedeemIn;

/**
 * Response Wallet-Wallet Redeem
 *
 * Successful Response
 */
export const zWalletWalletRedeemResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Me
 *
 * Successful Response
 */
export const zAdminAdminMeResponse = z.record(z.unknown());

export const zAdminAdminListUsersQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    q: z.string().nullish(),
    role: z.string().nullish(),
    status: z.string().nullish()
});

/**
 * Response Admin-Admin List Users
 *
 * Successful Response
 */
export const zAdminAdminListUsersResponse = z.record(z.unknown());

export const zAdminAdminGetUserPath = z.object({
    user_id: z.string()
});

/**
 * Response Admin-Admin Get User
 *
 * Successful Response
 */
export const zAdminAdminGetUserResponse = z.record(z.unknown());

export const zAdminAdminPatchUserBody = zUserPatchIn;

export const zAdminAdminPatchUserPath = z.object({
    user_id: z.string()
});

/**
 * Response Admin-Admin Patch User
 *
 * Successful Response
 */
export const zAdminAdminPatchUserResponse = z.record(z.unknown());

export const zAdminAdminAdjustCreditsBody = zAdjustCreditsIn;

export const zAdminAdminAdjustCreditsPath = z.object({
    user_id: z.string()
});

/**
 * Response Admin-Admin Adjust Credits
 *
 * Successful Response
 */
export const zAdminAdminAdjustCreditsResponse = z.record(z.unknown());

export const zAdminAdminUserLedgerPath = z.object({
    user_id: z.string()
});

export const zAdminAdminUserLedgerQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    kind: z.string().optional().default('all')
});

/**
 * Response Admin-Admin User Ledger
 *
 * Successful Response
 */
export const zAdminAdminUserLedgerResponse = z.record(z.unknown());

export const zAdminAdminListCardKeysQuery = z.object({
    status: z.string().nullish()
});

/**
 * Response Admin-Admin List Card Keys
 *
 * Successful Response
 */
export const zAdminAdminListCardKeysResponse = z.record(z.unknown());

export const zAdminAdminGenerateCardKeysBody = zGenerateCardKeysIn;

/**
 * Response Admin-Admin Generate Card Keys
 *
 * Successful Response
 */
export const zAdminAdminGenerateCardKeysResponse = z.record(z.unknown());

export const zAdminAdminRevokeCardKeysBody = zRevokeCardKeysIn;

/**
 * Response Admin-Admin Revoke Card Keys
 *
 * Successful Response
 */
export const zAdminAdminRevokeCardKeysResponse = z.record(z.unknown());

export const zAdminAdminListNoticesQuery = z.object({
    kind: z.string().nullish(),
    status: z.string().nullish()
});

/**
 * Response Admin-Admin List Notices
 *
 * Successful Response
 */
export const zAdminAdminListNoticesResponse = z.record(z.unknown());

export const zAdminAdminUpsertNoticeBody = zNoticeIn;

/**
 * Response Admin-Admin Upsert Notice
 *
 * Successful Response
 */
export const zAdminAdminUpsertNoticeResponse = z.record(z.unknown());

export const zAdminAdminDeleteNoticePath = z.object({
    notice_id: z.string()
});

/**
 * Response Admin-Admin Delete Notice
 *
 * Successful Response
 */
export const zAdminAdminDeleteNoticeResponse = z.record(z.unknown());

export const zAdminAdminGetNoticePath = z.object({
    notice_id: z.string()
});

/**
 * Response Admin-Admin Get Notice
 *
 * Successful Response
 */
export const zAdminAdminGetNoticeResponse = z.record(z.unknown());

export const zAdminAdminPlazaListQuery = z.object({
    status: z.string().nullish()
});

/**
 * Response Admin-Admin Plaza List
 *
 * Successful Response
 */
export const zAdminAdminPlazaListResponse = z.record(z.unknown());

export const zAdminAdminPlazaApprovePath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Approve
 *
 * Successful Response
 */
export const zAdminAdminPlazaApproveResponse = z.record(z.unknown());

/**
 * Body
 */
export const zAdminAdminPlazaRejectBody = zAppApiRoutesAdminCommonRejectIn.nullable();

export const zAdminAdminPlazaRejectPath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Reject
 *
 * Successful Response
 */
export const zAdminAdminPlazaRejectResponse = z.record(z.unknown());

export const zAdminAdminPlazaVisibilityBody = zPlazaVisibilityIn;

export const zAdminAdminPlazaVisibilityPath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Visibility
 *
 * Successful Response
 */
export const zAdminAdminPlazaVisibilityResponse = z.record(z.unknown());

export const zAdminAdminPlazaCoverBody = zPlazaCoverIn;

export const zAdminAdminPlazaCoverPath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Cover
 *
 * Successful Response
 */
export const zAdminAdminPlazaCoverResponse = z.record(z.unknown());

export const zAdminAdminPlazaTitleBody = zPlazaTitleIn;

export const zAdminAdminPlazaTitlePath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Title
 *
 * Successful Response
 */
export const zAdminAdminPlazaTitleResponse = z.record(z.unknown());

export const zAdminAdminPlazaDeletePath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Delete
 *
 * Successful Response
 */
export const zAdminAdminPlazaDeleteResponse = z.record(z.unknown());

export const zAdminAdminPlazaDetailPath = z.object({
    submission_id: z.string()
});

/**
 * Response Admin-Admin Plaza Detail
 *
 * Successful Response
 */
export const zAdminAdminPlazaDetailResponse = z.record(z.unknown());

export const zAdminAdminPlazaFeedQuery = z.object({
    tab: z.string().optional().default('recommended'),
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    userId: z.string().nullish()
});

/**
 * Response Admin-Admin Plaza Feed
 *
 * Successful Response
 */
export const zAdminAdminPlazaFeedResponse = z.record(z.unknown());

export const zAdminAdminPlazaPublishedQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    q: z.string().nullish()
});

/**
 * Response Admin-Admin Plaza Published
 *
 * Successful Response
 */
export const zAdminAdminPlazaPublishedResponse = z.record(z.unknown());

export const zAdminAdminDeleteLikeQuery = z.object({
    userId: z.string(),
    submissionId: z.string()
});

/**
 * Response Admin-Admin Delete Like
 *
 * Successful Response
 */
export const zAdminAdminDeleteLikeResponse = z.record(z.unknown());

export const zAdminAdminListLikesQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    q: z.string().nullish()
});

/**
 * Response Admin-Admin List Likes
 *
 * Successful Response
 */
export const zAdminAdminListLikesResponse = z.record(z.unknown());

export const zAdminAdminListProjectsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    q: z.string().nullish()
});

/**
 * Response Admin-Admin List Projects
 *
 * Successful Response
 */
export const zAdminAdminListProjectsResponse = z.record(z.unknown());

export const zAdminAdminListAssetsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(20),
    kind: z.string().nullish(),
    q: z.string().nullish()
});

/**
 * Response Admin-Admin List Assets
 *
 * Successful Response
 */
export const zAdminAdminListAssetsResponse = z.record(z.unknown());

export const zAdminAdminDeleteAssetPath = z.object({
    asset_id: z.string()
});

/**
 * Response Admin-Admin Delete Asset
 *
 * Successful Response
 */
export const zAdminAdminDeleteAssetResponse = z.record(z.unknown());

/**
 * Response Admin-Admin List Image Limit Presets
 *
 * Successful Response
 */
export const zAdminAdminListImageLimitPresetsResponse = z.record(z.unknown());

export const zAdminAdminSyncModelPricesBody = zSyncPricesIn;

/**
 * Response Admin-Admin Sync Model Prices
 *
 * Successful Response
 */
export const zAdminAdminSyncModelPricesResponse = z.record(z.unknown());

export const zAdminAdminListModelsQuery = z.object({
    kind: z.string().nullish(),
    q: z.string().nullish()
});

/**
 * Response Admin-Admin List Models
 *
 * Successful Response
 */
export const zAdminAdminListModelsResponse = z.record(z.unknown());

export const zAdminAdminUpsertModelBody = zModelUpsertIn;

/**
 * Response Admin-Admin Upsert Model
 *
 * Successful Response
 */
export const zAdminAdminUpsertModelResponse = z.record(z.unknown());

export const zAdminAdminDeleteModelPath = z.object({
    model_id: z.string()
});

/**
 * Response Admin-Admin Delete Model
 *
 * Successful Response
 */
export const zAdminAdminDeleteModelResponse = z.record(z.unknown());

export const zAdminAdminModelUsageSummaryQuery = z.object({
    fromTs: z.number().nullish(),
    toTs: z.number().nullish()
});

/**
 * Response Admin-Admin Model Usage Summary
 *
 * Successful Response
 */
export const zAdminAdminModelUsageSummaryResponse = z.record(z.unknown());

export const zAdminAdminModelUsageListQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(200).optional().default(50),
    source: z.string().nullish(),
    provider: z.string().nullish(),
    model: z.string().nullish(),
    userId: z.string().nullish(),
    status: z.string().nullish(),
    via: z.string().nullish(),
    kind: z.string().nullish(),
    fromTs: z.number().nullish(),
    toTs: z.number().nullish()
});

/**
 * Response Admin-Admin Model Usage List
 *
 * Successful Response
 */
export const zAdminAdminModelUsageListResponse = z.record(z.unknown());

export const zAdminAdminListPricingVersionsQuery = z.object({
    status: z.string().nullish(),
    pricingId: z.string().nullish(),
    modelId: z.string().nullish(),
    provider: z.string().nullish(),
    limit: z.number().int().gte(1).lte(500).optional().default(200)
});

/**
 * Response Admin-Admin List Pricing Versions
 *
 * Successful Response
 */
export const zAdminAdminListPricingVersionsResponse = z.record(z.unknown());

export const zAdminAdminUpsertPricingVersionBody = zPricingVersionIn;

/**
 * Response Admin-Admin Upsert Pricing Version
 *
 * Successful Response
 */
export const zAdminAdminUpsertPricingVersionResponse = z.record(z.unknown());

export const zAdminAdminGetPricingVersionPath = z.object({
    pricing_version_id: z.string()
});

/**
 * Response Admin-Admin Get Pricing Version
 *
 * Successful Response
 */
export const zAdminAdminGetPricingVersionResponse = z.record(z.unknown());

export const zAdminAdminSubmitPricingVersionPath = z.object({
    pricing_version_id: z.string()
});

/**
 * Response Admin-Admin Submit Pricing Version
 *
 * Successful Response
 */
export const zAdminAdminSubmitPricingVersionResponse = z.record(z.unknown());

export const zAdminAdminApprovePricingVersionPath = z.object({
    pricing_version_id: z.string()
});

/**
 * Response Admin-Admin Approve Pricing Version
 *
 * Successful Response
 */
export const zAdminAdminApprovePricingVersionResponse = z.record(z.unknown());

/**
 * Body
 */
export const zAdminAdminRejectPricingVersionBody = zAppApiRoutesAdminBillingRejectIn.nullable();

export const zAdminAdminRejectPricingVersionPath = z.object({
    pricing_version_id: z.string()
});

/**
 * Response Admin-Admin Reject Pricing Version
 *
 * Successful Response
 */
export const zAdminAdminRejectPricingVersionResponse = z.record(z.unknown());

export const zAdminAdminMarginSummaryQuery = z.object({
    fromTs: z.number().nullish(),
    toTs: z.number().nullish()
});

/**
 * Response Admin-Admin Margin Summary
 *
 * Successful Response
 */
export const zAdminAdminMarginSummaryResponse = z.record(z.unknown());

/**
 * Body
 */
export const zAdminAdminBillingQuoteBody = z.record(z.unknown()).nullable();

/**
 * Response Admin-Admin Billing Quote
 *
 * Successful Response
 */
export const zAdminAdminBillingQuoteResponse = z.record(z.unknown());

/**
 * Response Admin-Admin List Task Pricing
 *
 * Successful Response
 */
export const zAdminAdminListTaskPricingResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Design Runtime Settings
 *
 * Successful Response
 */
export const zAdminAdminDesignRuntimeSettingsResponse = z.record(z.unknown());

export const zAdminAdminUpsertDesignRuntimeSettingBody = zRuntimeSettingIn;

/**
 * Response Admin-Admin Upsert Design Runtime Setting
 *
 * Successful Response
 */
export const zAdminAdminUpsertDesignRuntimeSettingResponse = z.record(z.unknown());

export const zAdminAdminDesignSystemPromptsQuery = z.object({
    group: z.string().nullish(),
    selectable: z.boolean().nullish(),
    enabled: z.boolean().nullish().default(true)
});

/**
 * Response Admin-Admin Design System Prompts
 *
 * Successful Response
 */
export const zAdminAdminDesignSystemPromptsResponse = z.record(z.unknown());

export const zAdminAdminUpsertDesignSystemPromptBody = zSystemPromptIn;

/**
 * Response Admin-Admin Upsert Design System Prompt
 *
 * Successful Response
 */
export const zAdminAdminUpsertDesignSystemPromptResponse = z.record(z.unknown());

export const zAdminAdminDesignContentResyncQuery = z.object({
    force: z.boolean().optional().default(true)
});

/**
 * Response Admin-Admin Design Content Resync
 *
 * Successful Response
 */
export const zAdminAdminDesignContentResyncResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Design Canvas Tools
 *
 * Successful Response
 */
export const zAdminAdminDesignCanvasToolsResponse = z.record(z.unknown());

export const zAdminAdminUpsertDesignCanvasToolBody = zCanvasToolIn;

/**
 * Response Admin-Admin Upsert Design Canvas Tool
 *
 * Successful Response
 */
export const zAdminAdminUpsertDesignCanvasToolResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Design Metrics
 *
 * Successful Response
 */
export const zAdminAdminDesignMetricsResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Design Observability
 *
 * Successful Response
 */
export const zAdminAdminDesignObservabilityResponse = z.record(z.unknown());

export const zAdminAdminDesignDecisionLogsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(50),
    route: z.string().nullish(),
    intent: z.string().nullish(),
    status: z.string().nullish(),
    q: z.string().nullish()
});

/**
 * Response Admin-Admin Design Decision Logs
 *
 * Successful Response
 */
export const zAdminAdminDesignDecisionLogsResponse = z.record(z.unknown());

export const zAdminAdminDesignDecisionLogDetailPath = z.object({
    task_id: z.string()
});

/**
 * Response Admin-Admin Design Decision Log Detail
 *
 * Successful Response
 */
export const zAdminAdminDesignDecisionLogDetailResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Design Decision Logs Clear
 *
 * Successful Response
 */
export const zAdminAdminDesignDecisionLogsClearResponse = z.record(z.unknown());

export const zAdminAdminDesignStageReviewsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(100).optional().default(50),
    skillId: z.number().int().nullish(),
    minRating: z.number().int().gte(1).lte(5).nullish(),
    maxRating: z.number().int().gte(1).lte(5).nullish()
});

/**
 * Response Admin-Admin Design Stage Reviews
 *
 * Successful Response
 */
export const zAdminAdminDesignStageReviewsResponse = z.record(z.unknown());

export const zAdminAdminListOptimizePatchesQuery = z.object({
    status: z.string().nullish().default('pending')
});

/**
 * Response Admin-Admin List Optimize Patches
 *
 * Successful Response
 */
export const zAdminAdminListOptimizePatchesResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Generate Optimize Patches
 *
 * Successful Response
 */
export const zAdminAdminGenerateOptimizePatchesResponse = z.record(z.unknown());

export const zAdminAdminApplyOptimizePatchPath = z.object({
    patch_id: z.number().int()
});

/**
 * Response Admin-Admin Apply Optimize Patch
 *
 * Successful Response
 */
export const zAdminAdminApplyOptimizePatchResponse = z.record(z.unknown());

export const zAdminAdminDismissOptimizePatchPath = z.object({
    patch_id: z.number().int()
});

/**
 * Response Admin-Admin Dismiss Optimize Patch
 *
 * Successful Response
 */
export const zAdminAdminDismissOptimizePatchResponse = z.record(z.unknown());

export const zAdminAdminDesignDictTypesQuery = z.object({
    enabled: z.boolean().nullish()
});

/**
 * Response Admin-Admin Design Dict Types
 *
 * Successful Response
 */
export const zAdminAdminDesignDictTypesResponse = z.record(z.unknown());

export const zAdminAdminUpsertDesignDictTypeBody = zDesignDictTypeIn;

/**
 * Response Admin-Admin Upsert Design Dict Type
 *
 * Successful Response
 */
export const zAdminAdminUpsertDesignDictTypeResponse = z.record(z.unknown());

export const zAdminAdminDeleteDesignDictTypePath = z.object({
    type_id: z.number().int()
});

/**
 * Response Admin-Admin Delete Design Dict Type
 *
 * Successful Response
 */
export const zAdminAdminDeleteDesignDictTypeResponse = z.record(z.unknown());

export const zAdminAdminDesignDictsQuery = z.object({
    dictType: z.string().nullish(),
    enabled: z.boolean().nullish()
});

/**
 * Response Admin-Admin Design Dicts
 *
 * Successful Response
 */
export const zAdminAdminDesignDictsResponse = z.record(z.unknown());

export const zAdminAdminUpsertDesignDictBody = zDesignDictIn;

/**
 * Response Admin-Admin Upsert Design Dict
 *
 * Successful Response
 */
export const zAdminAdminUpsertDesignDictResponse = z.record(z.unknown());

export const zAdminAdminDeleteDesignDictPath = z.object({
    item_id: z.number().int()
});

export const zAdminAdminDeleteDesignDictQuery = z.object({
    hard: z.boolean().optional().default(false)
});

/**
 * Response Admin-Admin Delete Design Dict
 *
 * Successful Response
 */
export const zAdminAdminDeleteDesignDictResponse = z.record(z.unknown());

export const zAdminAdminDesignSkillsQuery = z.object({
    q: z.string().nullish(),
    enabled: z.boolean().nullish(),
    source: z.string().nullish()
});

/**
 * Response Admin-Admin Design Skills
 *
 * Successful Response
 */
export const zAdminAdminDesignSkillsResponse = z.record(z.unknown());

export const zAdminAdminUpsertDesignSkillBody = zDesignSkillIn;

/**
 * Response Admin-Admin Upsert Design Skill
 *
 * Successful Response
 */
export const zAdminAdminUpsertDesignSkillResponse = z.record(z.unknown());

export const zAdminAdminDeleteDesignSkillPath = z.object({
    skill_id: z.number().int()
});

/**
 * Response Admin-Admin Delete Design Skill
 *
 * Successful Response
 */
export const zAdminAdminDeleteDesignSkillResponse = z.record(z.unknown());

/**
 * Response Admin-Admin Resync Design Skills
 *
 * Successful Response
 */
export const zAdminAdminResyncDesignSkillsResponse = z.record(z.unknown());

export const zAdminAdminListKgTriplesQuery = z.object({
    userId: z.string().nullish(),
    limit: z.number().int().gte(1).lte(500).optional().default(100),
    offset: z.number().int().gte(0).optional().default(0)
});

/**
 * Response Admin-Admin List Kg Triples
 *
 * Successful Response
 */
export const zAdminAdminListKgTriplesResponse = z.record(z.unknown());

export const zAdminAdminDeleteKgTriplePath = z.object({
    triple_id: z.string()
});

/**
 * Response Admin-Admin Delete Kg Triple
 *
 * Successful Response
 */
export const zAdminAdminDeleteKgTripleResponse = z.record(z.unknown());

export const zAdminAdminRunColdArchiveQuery = z.object({
    retentionDays: z.number().int().gte(1).lte(3650).optional().default(30),
    batch: z.number().int().gte(1).lte(500).optional().default(80)
});

/**
 * Response Admin-Admin Run Cold Archive
 *
 * Successful Response
 */
export const zAdminAdminRunColdArchiveResponse = z.record(z.unknown());

export const zAdminAdminListFontsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    pageSize: z.number().int().gte(1).lte(500).optional().default(200)
});

/**
 * Response Admin-Admin List Fonts
 *
 * Successful Response
 */
export const zAdminAdminListFontsResponse = z.record(z.unknown());

export const zAdminAdminUpsertFontBody = zAdminFontUpsertIn;

/**
 * Response Admin-Admin Upsert Font
 *
 * Successful Response
 */
export const zAdminAdminUpsertFontResponse = z.record(z.unknown());

export const zAdminAdminFontsUploadBody = zBodyAdminAdminFontsUpload;

/**
 * Response Admin-Admin Fonts Upload
 *
 * Successful Response
 */
export const zAdminAdminFontsUploadResponse = z.record(z.unknown());

export const zAdminAdminDeleteFontPath = z.object({
    family: z.string()
});

/**
 * Response Admin-Admin Delete Font
 *
 * Successful Response
 */
export const zAdminAdminDeleteFontResponse = z.record(z.unknown());

export const zAdminAdminDeleteFontFacePath = z.object({
    family: z.string(),
    weight: z.number().int()
});

/**
 * Response Admin-Admin Delete Font Face
 *
 * Successful Response
 */
export const zAdminAdminDeleteFontFaceResponse = z.record(z.unknown());

export const zAdminAdminListHydrateDlqQuery = z.object({
    limit: z.number().int().gte(1).lte(200).optional().default(50)
});

/**
 * Response Admin-Admin List Hydrate Dlq
 *
 * Successful Response
 */
export const zAdminAdminListHydrateDlqResponse = z.record(z.unknown());

export const zAdminAdminReplayHydrateDlqBody = zDlqReplayIn;

/**
 * Response Admin-Admin Replay Hydrate Dlq
 *
 * Successful Response
 */
export const zAdminAdminReplayHydrateDlqResponse = z.record(z.unknown());

export const zAdminAdminDiscardHydrateDlqPath = z.object({
    job_id: z.string()
});

/**
 * Response Admin-Admin Discard Hydrate Dlq
 *
 * Successful Response
 */
export const zAdminAdminDiscardHydrateDlqResponse = z.record(z.unknown());

export const zAdminAdminListExportDlqQuery = z.object({
    limit: z.number().int().gte(1).lte(200).optional().default(50)
});

/**
 * Response Admin-Admin List Export Dlq
 *
 * Successful Response
 */
export const zAdminAdminListExportDlqResponse = z.record(z.unknown());

export const zAdminAdminReplayExportDlqBody = zDlqReplayIn;

/**
 * Response Admin-Admin Replay Export Dlq
 *
 * Successful Response
 */
export const zAdminAdminReplayExportDlqResponse = z.record(z.unknown());

export const zAdminAdminDiscardExportDlqPath = z.object({
    job_id: z.string()
});

/**
 * Response Admin-Admin Discard Export Dlq
 *
 * Successful Response
 */
export const zAdminAdminDiscardExportDlqResponse = z.record(z.unknown());

export const zMeMeLikedListQuery = z.object({
    page: z.number().int().optional().default(1),
    pageSize: z.number().int().optional().default(24)
});

/**
 * Response Me-Me Liked List
 *
 * Successful Response
 */
export const zMeMeLikedListResponse = z.record(z.unknown());

/**
 * Successful Response
 */
export const zMeMeLikedIdsResponse = zIdsOut;

export const zMeMeUnlikePath = z.object({
    submission_id: z.string()
});

/**
 * Response Me-Me Unlike
 *
 * Successful Response
 */
export const zMeMeUnlikeResponse = z.record(z.unknown());

export const zMeMeLikePath = z.object({
    submission_id: z.string()
});

/**
 * Response Me-Me Like
 *
 * Successful Response
 */
export const zMeMeLikeResponse = z.record(z.unknown());

export const zMeMeLikedSyncBody = zSyncLikedIn;

/**
 * Response Me-Me Liked Sync
 *
 * Successful Response
 */
export const zMeMeLikedSyncResponse = z.record(z.unknown());

/**
 * Successful Response
 */
export const zMeMeByokListResponse = zItemsOut;

export const zMeMeByokUpsertBody = zByokProviderIn;

/**
 * Successful Response
 */
export const zMeMeByokUpsertResponse = zItemOut;

export const zMeMeByokDeletePath = z.object({
    provider_id: z.string()
});

/**
 * Successful Response
 */
export const zMeMeByokDeleteResponse = zOkOut;

export const zUsersUsersSearchQuery = z.object({
    q: z.string().max(80).optional().default(''),
    limit: z.number().int().gte(1).lte(20).optional().default(12)
});

/**
 * Response Users-Users Search
 *
 * Successful Response
 */
export const zUsersUsersSearchResponse = z.record(z.unknown());

export const zUsersUsersLookupQuery = z.object({
    ids: z.string().max(800).optional().default('')
});

/**
 * Response Users-Users Lookup
 *
 * Successful Response
 */
export const zUsersUsersLookupResponse = z.record(z.unknown());

export const zNoticesNoticesListQuery = z.object({
    kind: z.string().nullish()
});

/**
 * Response Notices-Notices List
 *
 * Successful Response
 */
export const zNoticesNoticesListResponse = z.record(z.unknown());

export const zOrgsCreateOrgBody = zCreateOrgIn;

/**
 * Response Orgs-Create Org
 *
 * Successful Response
 */
export const zOrgsCreateOrgResponse = z.record(z.unknown());

/**
 * Response Orgs-List My Orgs
 *
 * Successful Response
 */
export const zOrgsListMyOrgsResponse = z.record(z.unknown());

/**
 * Response Orgs-List My Pending Invites
 *
 * Successful Response
 */
export const zOrgsListMyPendingInvitesResponse = z.record(z.unknown());

export const zOrgsAcceptInvitePath = z.object({
    invite_id: z.string()
});

/**
 * Response Orgs-Accept Invite
 *
 * Successful Response
 */
export const zOrgsAcceptInviteResponse = z.record(z.unknown());

export const zOrgsDeclineInvitePath = z.object({
    invite_id: z.string()
});

/**
 * Response Orgs-Decline Invite
 *
 * Successful Response
 */
export const zOrgsDeclineInviteResponse = z.record(z.unknown());

export const zOrgsGetOrgPath = z.object({
    org_id: z.string()
});

/**
 * Response Orgs-Get Org
 *
 * Successful Response
 */
export const zOrgsGetOrgResponse = z.record(z.unknown());

export const zOrgsRenameOrgBody = zRenameOrgIn;

export const zOrgsRenameOrgPath = z.object({
    org_id: z.string()
});

/**
 * Response Orgs-Rename Org
 *
 * Successful Response
 */
export const zOrgsRenameOrgResponse = z.record(z.unknown());

export const zOrgsListMembersPath = z.object({
    org_id: z.string()
});

/**
 * Response Orgs-List Members
 *
 * Successful Response
 */
export const zOrgsListMembersResponse = z.record(z.unknown());

export const zOrgsInviteMemberBody = zInviteMemberIn;

export const zOrgsInviteMemberPath = z.object({
    org_id: z.string()
});

/**
 * Response Orgs-Invite Member
 *
 * Successful Response
 */
export const zOrgsInviteMemberResponse = z.record(z.unknown());

export const zOrgsRemoveMemberPath = z.object({
    org_id: z.string(),
    user_id: z.string()
});

/**
 * Response Orgs-Remove Member
 *
 * Successful Response
 */
export const zOrgsRemoveMemberResponse = z.record(z.unknown());

export const zOrgsListOrgPendingInvitesPath = z.object({
    org_id: z.string()
});

/**
 * Response Orgs-List Org Pending Invites
 *
 * Successful Response
 */
export const zOrgsListOrgPendingInvitesResponse = z.record(z.unknown());

export const zPlazaPlazaSubmitBody = zSubmitIn;

/**
 * Response Plaza-Plaza Submit
 *
 * Successful Response
 */
export const zPlazaPlazaSubmitResponse = z.record(z.unknown());

export const zPlazaPlazaFeedQuery = z.object({
    page: z.number().int().optional().default(1),
    pageSize: z.number().int().nullish(),
    limit: z.number().int().nullish(),
    tab: z.string().optional().default('recommended'),
    category: z.string().nullish()
});

/**
 * Response Plaza-Plaza Feed
 *
 * Successful Response
 */
export const zPlazaPlazaFeedResponse = z.record(z.unknown());

export const zPlazaPlazaItemPath = z.object({
    submission_id: z.string()
});

/**
 * Response Plaza-Plaza Item
 *
 * Successful Response
 */
export const zPlazaPlazaItemResponse = z.record(z.unknown());

export const zPlazaPlazaItemUsePath = z.object({
    submission_id: z.string()
});

/**
 * Response Plaza-Plaza Item Use
 *
 * Successful Response
 */
export const zPlazaPlazaItemUseResponse = z.record(z.unknown());

export const zPlazaPlazaAdminListQuery = z.object({
    status: z.string().nullish()
});

/**
 * Response Plaza-Plaza Admin List
 *
 * Successful Response
 */
export const zPlazaPlazaAdminListResponse = z.record(z.unknown());

export const zPlazaPlazaAdminApprovePath = z.object({
    submission_id: z.string()
});

/**
 * Response Plaza-Plaza Admin Approve
 *
 * Successful Response
 */
export const zPlazaPlazaAdminApproveResponse = z.record(z.unknown());

/**
 * Body
 */
export const zPlazaPlazaAdminRejectBody = zAppApiRoutesPlazaRejectIn.nullable();

export const zPlazaPlazaAdminRejectPath = z.object({
    submission_id: z.string()
});

/**
 * Response Plaza-Plaza Admin Reject
 *
 * Successful Response
 */
export const zPlazaPlazaAdminRejectResponse = z.record(z.unknown());

export const zProjectsListMyProjectsQuery = z.object({
    page: z.number().int().optional().default(1),
    pageSize: z.number().int().optional().default(24),
    orgId: z.string().nullish()
});

/**
 * Successful Response
 */
export const zProjectsListMyProjectsResponse = zProjectListOut;

export const zProjectsUpsertBody = zUpsertProjectIn;

export const zProjectsUpsertHeaders = z.object({
    'If-Match': z.string().nullish()
});

/**
 * Successful Response
 */
export const zProjectsUpsertResponse = zProjectOneOut;

export const zProjectsBatchRemoveBody = zBatchDeleteIn;

/**
 * Successful Response
 */
export const zProjectsBatchRemoveResponse = zBatchDeleteOut;

export const zProjectsRemovePath = z.object({
    project_id: z.string()
});

/**
 * Successful Response
 */
export const zProjectsRemoveResponse = zOkOut;

export const zProjectsGetOnePath = z.object({
    project_id: z.string()
});

/**
 * Successful Response
 */
export const zProjectsGetOneResponse = zProjectOneOut;

export const zProjectsPatchOneBody = zPatchProjectIn;

export const zProjectsPatchOneHeaders = z.object({
    'If-Match': z.string().nullish()
});

export const zProjectsPatchOnePath = z.object({
    project_id: z.string()
});

/**
 * Successful Response
 */
export const zProjectsPatchOneResponse = zProjectOneOut;

export const zProjectsSetProjectOrgBody = zSetProjectOrgIn;

export const zProjectsSetProjectOrgPath = z.object({
    project_id: z.string()
});

/**
 * Successful Response
 */
export const zProjectsSetProjectOrgResponse = zProjectOneOut;

export const zSharesSharesCreateBody = zCreateShareIn;

/**
 * Response Shares-Shares Create
 *
 * Successful Response
 */
export const zSharesSharesCreateResponse = z.record(z.unknown());

export const zSharesSharesGetPath = z.object({
    share_id: z.string()
});

/**
 * Response Shares-Shares Get
 *
 * Successful Response
 */
export const zSharesSharesGetResponse = z.record(z.unknown());

export const zSharesSharesPatchBody = zUpdateShareMetaIn;

export const zSharesSharesPatchPath = z.object({
    share_id: z.string()
});

/**
 * Response Shares-Shares Patch
 *
 * Successful Response
 */
export const zSharesSharesPatchResponse = z.record(z.unknown());

export const zSharesSharesUpdateDocumentBody = zUpdateShareDocumentIn;

export const zSharesSharesUpdateDocumentPath = z.object({
    share_id: z.string()
});

/**
 * Response Shares-Shares Update Document
 *
 * Successful Response
 */
export const zSharesSharesUpdateDocumentResponse = z.record(z.unknown());

export const zCollabCollabRoomTokenBody = zRoomTokenIn;

/**
 * Response Collab-Collab Room Token
 *
 * Successful Response
 */
export const zCollabCollabRoomTokenResponse = z.record(z.unknown());

export const zFontsListFontsEndpointQuery = z.object({
    page: z.number().int().optional().default(1),
    pageSize: z.number().int().optional().default(100)
});

/**
 * Response Fonts-List Fonts Endpoint
 *
 * Successful Response
 */
export const zFontsListFontsEndpointResponse = z.record(z.unknown());

export const zFontsRegisterFontBody = zFontRegisterIn;

/**
 * Response Fonts-Register Font
 *
 * Successful Response
 */
export const zFontsRegisterFontResponse = z.record(z.unknown());

export const zFontsUploadFontFileBody = zBodyFontsUploadFontFile;

/**
 * Response Fonts-Upload Font File
 *
 * Successful Response
 */
export const zFontsUploadFontFileResponse = z.record(z.unknown());

export const zFontsDeleteMyFontPath = z.object({
    family: z.string()
});

/**
 * Response Fonts-Delete My Font
 *
 * Successful Response
 */
export const zFontsDeleteMyFontResponse = z.record(z.unknown());

export const zAssetsListMyAssetsQuery = z.object({
    page: z.number().int().optional().default(1),
    pageSize: z.number().int().optional().default(24),
    kind: z.string().nullish(),
    q: z.string().nullish()
});

/**
 * Response Assets-List My Assets
 *
 * Successful Response
 */
export const zAssetsListMyAssetsResponse = z.record(z.unknown());

export const zAssetsRegisterMyAssetBody = zRegisterAssetIn;

/**
 * Response Assets-Register My Asset
 *
 * Successful Response
 */
export const zAssetsRegisterMyAssetResponse = z.record(z.unknown());

export const zAssetsDeleteMyAssetPath = z.object({
    asset_id: z.string()
});

/**
 * Response Assets-Delete My Asset
 *
 * Successful Response
 */
export const zAssetsDeleteMyAssetResponse = z.record(z.unknown());

export const zUploadsGetUploadContentByUrlQuery = z.object({
    url: z.string().min(1)
});

export const zUploadsDeleteUploadedFilePath = z.object({
    object_key: z.string()
});

/**
 * Response Uploads-Delete Uploaded File
 *
 * Successful Response
 */
export const zUploadsDeleteUploadedFileResponse = z.record(z.unknown());

export const zUploadsGetUploadedFilePath = z.object({
    object_key: z.string()
});

export const zUploadsCreateUploadSessionBody = zUploadSessionCreate;

/**
 * Successful Response
 */
export const zUploadsCreateUploadSessionResponse = zUploadSessionResponse;

export const zUploadsUploadJobPartPath = z.object({
    job_id: z.string(),
    part_number: z.number().int()
});

/**
 * Successful Response
 */
export const zUploadsUploadJobPartResponse = zUploadPartResponse;

export const zUploadsCompleteUploadJobPath = z.object({
    job_id: z.string()
});

export const zUploadsAbortUploadJobPath = z.object({
    job_id: z.string()
});

export const zUploadsGetUploadJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zUploadsGetUploadJobResponse = zUploadJobStatusResponse;

export const zUploadsStreamUploadJobEventsPath = z.object({
    job_id: z.string()
});

export const zChatSessionsGetSessionsQuery = z.object({
    projectId: z.string().optional().default('__none__')
});

/**
 * Response Chat-Sessions-Get Sessions
 *
 * Successful Response
 */
export const zChatSessionsGetSessionsResponse = z.record(z.unknown());

export const zChatSessionsPutSessionBody = zUpsertSessionIn;

/**
 * Response Chat-Sessions-Put Session
 *
 * Successful Response
 */
export const zChatSessionsPutSessionResponse = z.record(z.unknown());

export const zChatSessionsRemoveSessionPath = z.object({
    session_id: z.string()
});

/**
 * Response Chat-Sessions-Remove Session
 *
 * Successful Response
 */
export const zChatSessionsRemoveSessionResponse = z.record(z.unknown());

export const zImportImportImageBody = zBodyImportImportImage;

/**
 * Successful Response
 */
export const zImportImportImageResponse = zImportResponse;

export const zImportJobsCreateImportJobBody = zBodyImportJobsCreateImportJob;

/**
 * Successful Response
 */
export const zImportJobsCreateImportJobResponse = zJobCreateResponse;

export const zImportJobsGetImportJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zImportJobsGetImportJobResponse = zJobStatusResponse;

export const zDesignHydrateJobsCreateHydrateJobBody = zHydrateJobCreateRequest;

/**
 * Successful Response
 */
export const zDesignHydrateJobsCreateHydrateJobResponse = zHydrateJobCreateResponse;

export const zDesignHydrateJobsGetHydrateJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zDesignHydrateJobsGetHydrateJobResponse = zHydrateJobStatusResponse;

export const zDesignExportJobsCreateExportJobBody = zExportJobCreateRequest;

/**
 * Successful Response
 */
export const zDesignExportJobsCreateExportJobResponse = zExportJobCreateResponse;

export const zDesignExportJobsGetExportJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zDesignExportJobsGetExportJobResponse = zExportJobStatusResponse;

export const zDesignExportJobsDownloadExportJobPath = z.object({
    job_id: z.string()
});

export const zChatImageJobsCreateImageJobBody = zImageJobCreateRequest;

/**
 * Successful Response
 */
export const zChatImageJobsCreateImageJobResponse = zImageJobCreateResponse;

export const zChatImageJobsGetImageJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zChatImageJobsGetImageJobResponse = zImageJobStatusResponse;

export const zChatImageJobsStreamImageJobEventsPath = z.object({
    job_id: z.string()
});

export const zChatVideoJobsCreateVideoJobBody = zVideoJobCreateRequest;

/**
 * Successful Response
 */
export const zChatVideoJobsCreateVideoJobResponse = zVideoJobCreateResponse;

export const zChatVideoJobsGetVideoJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zChatVideoJobsGetVideoJobResponse = zVideoJobStatusResponse;

export const zChatVideoJobsStreamVideoJobEventsPath = z.object({
    job_id: z.string()
});

export const zChatAudioJobsCreateAudioJobBody = zAudioJobCreateRequest;

/**
 * Successful Response
 */
export const zChatAudioJobsCreateAudioJobResponse = zAudioJobCreateResponse;

export const zChatAudioJobsGetAudioJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zChatAudioJobsGetAudioJobResponse = zAudioJobStatusResponse;

export const zChatAudioJobsStreamAudioJobEventsPath = z.object({
    job_id: z.string()
});

export const zChatLottieJobsCreateLottieJobBody = zLottieJobCreateRequest;

/**
 * Successful Response
 */
export const zChatLottieJobsCreateLottieJobResponse = zLottieJobCreateResponse;

export const zChatLottieJobsGetLottieJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zChatLottieJobsGetLottieJobResponse = zLottieJobStatusResponse;

export const zChatLottieJobsStreamLottieJobEventsPath = z.object({
    job_id: z.string()
});

/**
 * Response Chat-Get Models
 *
 * Successful Response
 */
export const zChatGetModelsResponse = z.record(z.unknown());

export const zChatPostMessageBody = zAppApiRoutesChatChatMessageIn;

/**
 * Response Chat-Get Agent Tools
 *
 * Successful Response
 */
export const zChatGetAgentToolsResponse = z.record(z.unknown());

export const zChatPostAgentTurnBody = zAgentTurnIn;

export const zChatPostImageBody = zImageGenerateIn;

/**
 * Response Chat-Post Image
 *
 * Successful Response
 */
export const zChatPostImageResponse = z.record(z.unknown());

export const zChatPostVideoBody = zVideoGenerateIn;

/**
 * Response Chat-Post Video
 *
 * Successful Response
 */
export const zChatPostVideoResponse = z.record(z.unknown());

export const zChatPostAudioBody = zAudioGenerateIn;

/**
 * Response Chat-Post Audio
 *
 * Successful Response
 */
export const zChatPostAudioResponse = z.record(z.unknown());

/**
 * Response Image-Tools-List Image Tools
 *
 * Successful Response
 */
export const zImageToolsListImageToolsResponse = z.record(z.unknown());

export const zImageToolsPostImageProcessBody = zImageProcessIn;

/**
 * Response Image-Tools-Post Image Process
 *
 * Successful Response
 */
export const zImageToolsPostImageProcessResponse = z.record(z.unknown());

export const zImageProcessJobsCreateImageProcessJobBody = zImageProcessJobCreateRequest;

/**
 * Successful Response
 */
export const zImageProcessJobsCreateImageProcessJobResponse = zImageProcessJobCreateResponse;

export const zImageProcessJobsGetImageProcessJobPath = z.object({
    job_id: z.string()
});

/**
 * Successful Response
 */
export const zImageProcessJobsGetImageProcessJobResponse = zImageProcessJobStatusResponse;

export const zImageProcessJobsStreamImageProcessJobEventsPath = z.object({
    job_id: z.string()
});

/**
 * Response Mockup-List Mockup Tools
 *
 * Successful Response
 */
export const zMockupListMockupToolsResponse = z.record(z.unknown());

export const zMockupGetMockupTemplateKitPath = z.object({
    template_id: z.string()
});

export const zMockupGetMockupTemplateKitQuery = z.object({
    scale: z.number().optional().default(0.5)
});

/**
 * Response Mockup-Get Mockup Template Kit
 *
 * Successful Response
 */
export const zMockupGetMockupTemplateKitResponse = z.record(z.unknown());

export const zMockupPostMockupAutoBakeBody = zMockupAutoBakeIn;

/**
 * Response Mockup-Post Mockup Auto Bake
 *
 * Successful Response
 */
export const zMockupPostMockupAutoBakeResponse = z.record(z.unknown());

export const zMockupPostMockupRenderBody = zMockupRenderIn;

/**
 * Response Mockup-Post Mockup Render
 *
 * Successful Response
 */
export const zMockupPostMockupRenderResponse = z.record(z.unknown());

export const zMockupPostMockupBatchRenderBody = zMockupBatchIn;

/**
 * Response Mockup-Post Mockup Batch Render
 *
 * Successful Response
 */
export const zMockupPostMockupBatchRenderResponse = z.record(z.unknown());

/**
 * Response Design-Design Catalog
 *
 * Successful Response
 */
export const zDesignDesignCatalogResponse = z.record(z.unknown());

/**
 * Response Design-Design Canvas Tools
 *
 * Successful Response
 */
export const zDesignDesignCanvasToolsResponse = z.record(z.unknown());

export const zDesignDesignSkillsPickerQuery = z.object({
    scene: z.string().nullish(),
    mine: z.boolean().optional().default(false),
    manage: z.boolean().optional().default(false)
});

/**
 * Response Design-Design Skills Picker
 *
 * Successful Response
 */
export const zDesignDesignSkillsPickerResponse = z.record(z.unknown());

export const zDesignDesignSkillsUpsertBody = zUserSkillIn;

/**
 * Response Design-Design Skills Upsert
 *
 * Successful Response
 */
export const zDesignDesignSkillsUpsertResponse = z.record(z.unknown());

export const zDesignDesignSkillsImportZipBody = zBodyDesignDesignSkillsImportZip;

/**
 * Response Design-Design Skills Import Zip
 *
 * Successful Response
 */
export const zDesignDesignSkillsImportZipResponse = z.record(z.unknown());

export const zDesignDesignPluginsInstallBody = zBodyDesignDesignPluginsInstall;

/**
 * Response Design-Design Plugins Install
 *
 * Successful Response
 */
export const zDesignDesignPluginsInstallResponse = z.record(z.unknown());

export const zDesignDesignSkillsSetEnabledBody = zUserSkillEnabledIn;

export const zDesignDesignSkillsSetEnabledPath = z.object({
    skill_id: z.number().int()
});

/**
 * Response Design-Design Skills Set Enabled
 *
 * Successful Response
 */
export const zDesignDesignSkillsSetEnabledResponse = z.record(z.unknown());

export const zDesignDesignSkillsDeletePath = z.object({
    skill_id: z.number().int()
});

/**
 * Response Design-Design Skills Delete
 *
 * Successful Response
 */
export const zDesignDesignSkillsDeleteResponse = z.record(z.unknown());

export const zDesignDesignRunBody = zDesignRunIn;

export const zDesignDesignRunSceneFeedbackBody = zSceneFeedbackIn;

export const zDesignDesignRunSceneFeedbackPath = z.object({
    task_id: z.string()
});

/**
 * Response Design-Design Run Scene Feedback
 *
 * Successful Response
 */
export const zDesignDesignRunSceneFeedbackResponse = z.record(z.unknown());

export const zDesignDesignRunStatusPath = z.object({
    task_id: z.string()
});

/**
 * Response Design-Design Run Status
 *
 * Successful Response
 */
export const zDesignDesignRunStatusResponse = z.record(z.unknown());

export const zDesignDesignRunEventsPath = z.object({
    task_id: z.string()
});

export const zDesignDesignRunEventsQuery = z.object({
    after_seq: z.number().int().gte(0).optional().default(0),
    limit: z.number().int().gte(1).lte(96).optional().default(96)
});

/**
 * Response Design-Design Run Events
 *
 * Successful Response
 */
export const zDesignDesignRunEventsResponse = z.record(z.unknown());

export const zDesignDesignRunTracePath = z.object({
    task_id: z.string()
});

export const zDesignDesignRunTraceQuery = z.object({
    after_seq: z.number().int().gte(0).optional().default(0),
    limit: z.number().int().gte(1).lte(256).optional().default(256)
});

/**
 * Response Design-Design Run Trace
 *
 * Successful Response
 */
export const zDesignDesignRunTraceResponse = z.record(z.unknown());

export const zDesignDesignRunCommandsPath = z.object({
    task_id: z.string()
});

export const zDesignDesignRunCommandsQuery = z.object({
    after_seq: z.number().int().gte(0).optional().default(0)
});

/**
 * Response Design-Design Run Commands
 *
 * Successful Response
 */
export const zDesignDesignRunCommandsResponse = z.record(z.unknown());

export const zDesignDesignRunCommandsAckBody = zCanvasCommandAckIn;

export const zDesignDesignRunCommandsAckPath = z.object({
    task_id: z.string()
});

/**
 * Response Design-Design Run Commands Ack
 *
 * Successful Response
 */
export const zDesignDesignRunCommandsAckResponse = z.record(z.unknown());

export const zDesignDesignRunPausePath = z.object({
    task_id: z.string()
});

/**
 * Response Design-Design Run Pause
 *
 * Successful Response
 */
export const zDesignDesignRunPauseResponse = z.record(z.unknown());

export const zDesignDesignRunCancelPath = z.object({
    task_id: z.string()
});

/**
 * Response Design-Design Run Cancel
 *
 * Successful Response
 */
export const zDesignDesignRunCancelResponse = z.record(z.unknown());

/**
 * Body
 */
export const zDesignDesignRunResumeBody = zDesignResumeIn.nullable();

export const zDesignDesignRunResumePath = z.object({
    task_id: z.string()
});

export const zDesignDesignLottieGenerateBody = zLottieGenerateIn;

/**
 * Response Design-Design Lottie Generate
 *
 * Successful Response
 */
export const zDesignDesignLottieGenerateResponse = z.record(z.unknown());

export const zDesignDesignLongMemoryBody = zLongMemoryIn;

/**
 * Response Design-Design Long Memory
 *
 * Successful Response
 */
export const zDesignDesignLongMemoryResponse = z.record(z.unknown());

/**
 * Response Mcp-Canvas-List Tools
 *
 * Successful Response
 */
export const zMcpCanvasListToolsResponse = z.record(z.unknown());

export const zMcpCanvasCallToolBody = zMcpToolCallIn;

/**
 * Response Mcp-Canvas-Call Tool
 *
 * Successful Response
 */
export const zMcpCanvasCallToolResponse = z.record(z.unknown());

export const zMcpCanvasSessionHeartbeatBody = zMcpHeartbeatIn;

/**
 * Response Mcp-Canvas-Session Heartbeat
 *
 * Successful Response
 */
export const zMcpCanvasSessionHeartbeatResponse = z.record(z.unknown());

export const zMcpCanvasListPendingQuery = z.object({
    project_id: z.string().min(1).max(128),
    limit: z.number().int().gte(1).lte(32).optional().default(8)
});

/**
 * Response Mcp-Canvas-List Pending
 *
 * Successful Response
 */
export const zMcpCanvasListPendingResponse = z.record(z.unknown());

export const zMcpCanvasAckPendingBody = zMcpPendingAckIn;

/**
 * Response Mcp-Canvas-Ack Pending
 *
 * Successful Response
 */
export const zMcpCanvasAckPendingResponse = z.record(z.unknown());
